<div class="app__discovery--collection--widget--container">
  <div class="app__itemCard-radioGroup items-start mt-5">
    <p class="app__sub-title text-[#53565B] font-semibold">
      <span class="font-bold text-[#25508E]"> {{ data?.group_name }} Items </span> for
      <span class="font-bold text-[#25508E]">{{ currentUser?.first_name }}’s {{ data?.path_name }} </span>
    </p>
  </div>
  <div class="app__discovery--inner--section">
    @if (onBoardingChecklists) {
      <div class="mt-7">
        @for (checklist of onBoardingChecklists; track checklist; let last = $last) {
          <div [ngClass]="!last ? 'mb-2' : ''">
            <div class="w-full">
              <mat-accordion>
                <mat-expansion-panel class="shadow-none mb-5 h-auto" [expanded]="true">
                  <mat-expansion-panel-header class="disable_ripple hover:bg-white">
                    <mat-panel-title>
                      <p class="app__form--attribute--title text-base text-left font-semibold mb-0" (click)="$event.stopPropagation()">
                        {{ checklist?.group_name }}
                      </p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="flex pt-5 pb-3">
                    <div class="w-[50%] pl-3">
                      <span class="app__form--attribute--title text-sm font-medium text-[#89817d]"> Name </span>
                    </div>
                    <div class="app__centered-item w-[12.5%]">
                      <span class="app__form--attribute--title text-sm font-medium text-[#89817d]"> Remove </span>
                    </div>
                    <div class="app__centered-item w-[12.5%]">
                      <span class="app__form--attribute--title text-sm font-medium text-[#89817d]"> Later </span>
                    </div>
                    <div class="app__centered-item w-[12.5%]">
                      <span class="app__form--attribute--title text-sm font-medium text-[#89817d]"> Digital </span>
                    </div>
                    <div class="app__centered-item w-[12.5%]">
                      <span class="app__form--attribute--title text-sm font-medium text-[#89817d]"> Physical </span>
                    </div>
                  </div>
                  @for (form of checklist.forms; track form) {
                    <div class="mb-4">
                      <div class="w-full min-h-[92px] h-auto rounded-[10px] bg-white border-solid border border-[#d3dce8b2]">
                        <div class="m-3">
                          <span class="app__form--attribute--title text-sm font-semibold">
                            {{ form.form_name | truncateStrPipe : 35 }}
                          </span>
                        </div>
                        <hr />
                        @for (reminder of form.reminders; track reminder; let index = $index; let last = $last) {
                          <div>
                            <div class="flex m-3 mx-0">
                              <div class="w-[50%] ml-3">
                                <span class="app__form--attribute--title text-sm text-[#53565b] font-semibold">
                                  {{ reminder.description }}
                                </span>
                              </div>
                              <div class="w-[12.5%] app__centered-item">
                                <span
                                  class="hover:cursor-pointer"
                                  [matTooltip]="reminder?.onboarding_status !== 'remove' ? 'Remove this from the list' : ''"
                                  (click)="updateChecklist(reminder, 'remove')"
                                  >
                                  <img
                            [src]="
                              reminder?.onboarding_status === 'remove'
                                ? '../../../../../../assets/images/discovery/checklist_active_remove.svg'
                                : '../../../../../../assets/images/discovery/checklist_disabled_remove.svg'
                            "
                                    />
                                  </span>
                                </div>
                                <div class="w-[12.5%] app__centered-item">
                                  <span
                                    class="hover:cursor-pointer"
                                    [matTooltip]="reminder?.onboarding_status !== 'later' ? 'Come back to this later' : ''"
                                    (click)="updateChecklist(reminder, 'later')"
                                    >
                                    <img
                            [src]="
                              reminder?.onboarding_status === 'later'
                                ? '../../../../../../assets/images/discovery/checklist_active_later.svg'
                                : '../../../../../../assets/images/discovery/checklist_disabled_later.svg'
                            "
                                      />
                                    </span>
                                  </div>
                                  <div class="w-[12.5%] app__centered-item">
                                    <span
                                      class="hover:cursor-pointer"
                                      [matTooltip]="reminder?.onboarding_status !== 'digital' ? 'A digital copy was collected' : ''"
                                      (click)="updateChecklist(reminder, 'digital')"
                                      >
                                      <img
                            [src]="
                              reminder?.onboarding_status === 'digital'
                                ? '../../../../../../assets/images/discovery/checklist_active_digital.svg'
                                : '../../../../../../assets/images/discovery/checklist_disabled_digital.svg'
                            "
                                        />
                                      </span>
                                    </div>
                                    <div class="w-[12.5%] app__centered-item">
                                      <span
                                        class="hover:cursor-pointer"
                                        [matTooltip]="reminder?.onboarding_status !== 'physical' ? ' A physical copy was collected ' : ''"
                                        (click)="updateChecklist(reminder, 'physical')"
                                        >
                                        <img
                            [src]="
                              reminder?.onboarding_status === 'physical'
                                ? '../../../../../../assets/images/discovery/checklist_active_physical.svg'
                                : '../../../../../../assets/images/discovery/checklist_disabled_physical.svg'
                            "
                                          />
                                        </span>
                                      </div>
                                    </div>
                                    @if (!last) {
                                      <hr class="m-3" />
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  </div>
                }
              </div>
            } @else {
              @for (item of [{}, {}, {}]; track item) {
                <div class="mt-7">
                  <div class="ph-item w-full loader-body-item p-0 border-none border-0 m-0">
                    <div class="ph-col-12 p-0">
                      <div class="ph-row">
                        <div class="ph-col-12 h-16"></div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
        <mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
        <div class="flex items-start justify-between w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
          <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
            <span class="app__centered-item gap-2 text-[#18191C]"
              ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
              >
            </button>
            <div class="w-[158px]">
              <button
      [class]="
        allHaveOnBoardingStatus
          ? 'app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0'
          : 'app__btn--disabled mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0'
      "
                [matTooltip]="!allHaveOnBoardingStatus ? 'Please make a selection for each item to continue' : ''"
                type="submit"
                (click)="updateOnboardingChecklist()"
                >
                Continue
              </button>
            </div>
          </div>
